import { Link, useParams } from 'react-router-dom';
import usePageMeta from '../lib/usePageMeta';
import PageHero from '../components/PageHero';
import Icon from '../components/Icon';
import { PostCard } from '../components/Blocks';
import { POSTS, POST_BY_SLUG } from '../data';
import NotFound from './NotFound';

export default function BlogPost() {
  const { slug } = useParams();
  const post = POST_BY_SLUG[slug];
  usePageMeta(post ? post.title : 'Not found', post ? post.excerpt : '');
  if (!post) return <NotFound />;
  const more = POSTS.filter((p) => p.slug !== post.slug).slice(0, 3);

  return (
    <>
      <PageHero eyebrow={post.cat} title={post.title} description={`${post.date} · ${post.read}`} crumbs={[{ label: 'Blog', to: '/blog' }, { label: post.cat }]} />

      <article className="section bg-white">
        <div className="container-x">
          <div className="mx-auto max-w-3xl">
            <p className="text-xl font-medium leading-relaxed text-ink" data-anim="up">{post.excerpt}</p>
            <div className="mt-8 space-y-6 text-lg leading-[1.85] text-slate-600">
              {post.body.map((para, i) => <p key={i} data-anim="up">{para}</p>)}
            </div>
            <div className="mt-14 flex flex-col items-start justify-between gap-5 rounded-3xl bg-gradient-to-br from-brand to-ink p-8 text-white sm:flex-row sm:items-center" data-anim="zoom">
              <div>
                <h2 className="font-display text-2xl font-bold">Have a project in mind?</h2>
                <p className="mt-1 text-white/70">Talk to our team for a free consultation.</p>
              </div>
              <Link to="/contact" className="btn-primary shrink-0">Contact us <Icon name="arrow" className="h-4 w-4" /></Link>
            </div>
            <Link to="/blog" className="mt-10 inline-flex items-center gap-2 font-semibold text-brand"><Icon name="arrow" className="h-4 w-4 rotate-180" /> Back to all articles</Link>
          </div>
        </div>
      </article>

      <section className="section bg-brand-soft">
        <div className="container-x">
          <h2 className="h2 text-ink" data-anim="left">Keep reading</h2>
          <div className="mt-10 grid gap-7 md:grid-cols-3" data-anim="up" data-stagger>
            {more.map((p) => <PostCard key={p.slug} post={p} />)}
          </div>
        </div>
      </section>
    </>
  );
}
